import { ISupplementDetailState } from '../../types/supplement/supplementsTypes';
import endpoints from '../../utils/commonVariables/endpoints';
import {
    savableEntities,
    viewModelEntities,
} from '../../utils/commonVariables/entityKeys';
import convertToOvariant from '../../utils/convertToOvariant';
import { supplierSupplementViewModelStructure } from '../../utils/viewModelStructures/supplierSupplement';
import api from '../api';
import { adaptSupplementToDDBB } from './supplementAdapters';

export const getSupplementData = async (id: string) => {
    const endpoint = endpoints.viewModel(
        viewModelEntities.SupplierSupplement,
        id
    );
    return api.post(endpoint, supplierSupplementViewModelStructure);
};

export const saveSupplementToDDBB = async (
    supplementData: ISupplementDetailState
) => {
    const supplementToDDBB = adaptSupplementToDDBB(supplementData);
    const objectToSend = convertToOvariant(
        savableEntities.SupplierSupplement,
        supplementToDDBB,
        supplementToDDBB.Id,
        supplierSupplementViewModelStructure
    );

    return api.post(endpoints.commonSave, objectToSend);
};
